/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ResumeConversationRequest = {
  plan_ids: Array<string>;
  conversation_type: ResumeConversationRequest.conversation_type;
};
export namespace ResumeConversationRequest {
  export enum conversation_type {
    DEEP_DIVE = 'deep_dive',
    PLAN_COMPARISON = 'plan_comparison',
  }
}
